
import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  Stack,
  Alert,
  AlertIcon,
  IconButton
} from "@chakra-ui/react";

import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";

// Custom components
import ItemTakenDown from "views/admin/suspicious/components/ItemTakenDown";
import CommentPopover from "./CommentPopover";
import Card from "components/card/Card.js";
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useListContext } from '../../../../contexts/listContext';
import { useProductStore } from "../../../../store/useProductStore";
import Loader from "../../../../components/loader/Loader"




export default function TakenDown(props) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { userId, takenDownProducts, fetchProductsByStatus, isAdmin, isLoading } = props;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const [productsToShow, setProductsToShow] = useState(20); // Initial number of products to show
  const productsPerPage = 20; // Number of products to load per page
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [updateSeller, setUpdateSeller] = useState([]);
  const { list, checkedPlatforms, abuse_type, dateFilter, checkedAbuseTypes } = useListContext();
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [sortedProducts, setSortedProducts] = useState([]);
  const { products, moveProducts, updateProducts } = useProductStore();

  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [viewMode, setViewMode] = useState("grid")

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
  };
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  const loadMore = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };
  const loadLess = () => {
    setProductsToShow(productsToShow - productsPerPage);
  };

  const handleUpdateSeller = async (product, seller_status) => {
    try {
      const existingIndex = updateSeller.findIndex(
        (item) => item.product.psm_id === product.psm_id
      );

      if (existingIndex !== -1) {
        // Product already exists, update its status
        setUpdateSeller((prev) => {
          const updatedSeller = [...prev];
          updatedSeller[existingIndex].seller_status = seller_status;
          return updatedSeller;
        });
      } else {
        // Product does not exist, add it to the list
        setUpdateSeller([...updateSeller, { product, seller_status }]);
      }
      //console.log('updateSeller', updateSeller);
    } catch (err) {
      console.error("err in handleInserSeller", err);
    }
  };

  const removeFromUpdate = async (product, seller_status) => {
    setUpdateSeller(
      updateSeller.filter((item) => {
        return !(item.product.psm_id === product.psm_id);
      })
    );
    //console.log('removed from list new Update Seller:', updateSeller);
  };

  const handleSaveChanges = async () => {
    try {
      //console.log(updateSeller);
      const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;

      const response = await fetch(
        `${backendUrl}/api/sellers/updateSellerStatus/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sellers: updateSeller,
            uid: uid,
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Changes Saved");
        setUpdateSeller([]);
      } else if (response.status === 400) {
        handleFailureAlert("Error Saving Changes. Please try again!");
      }
      setStatusUpdate(true);
    } catch (e) {
      //console.log("error in handleSavechanges");
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text) {
        setSortedProducts(
          products["takenDown"].filter(
            (item) =>
              item.title?.toLowerCase().includes(text?.toLowerCase()) ||
              item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
              item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
              item.prod_code?.toLowerCase().includes(text?.toLowerCase())
          )
        );
      } else {
        setSortedProducts(products["takenDown"]);
        handleFilter();
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  const handleFilter = async () => {
    try {
      let keywordId = list.map((item) => item.id);
      let platformIds = checkedPlatforms.map((item) => item.id);
      let abuseTypeId = checkedAbuseTypes.map((item) => item.id);

      let allProducts = products["takenDown"] || [];
      let filtered = allProducts;
      // Keyword filter
      if (keywordId.length > 0) {
        filtered = filtered.filter((item) =>
          keywordId.includes(item.keyword_id)
        );
      }

      // Platform filter
      if (platformIds.length > 0) {
        filtered = filtered.filter((item) =>
          platformIds.includes(item.platform_id)
        );
      }

      filtered = filtered.filter((item) =>
        abuseTypeId?.includes(item.abuse_type_id) || item.abuse_type_id === null
      );




      // Date filter
      if (dateFilter.startDate && dateFilter.endDate) {
        let startDate = new Date(dateFilter.startDate);
        let endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);

        filtered = filtered.filter((item) => {
          if (!item.date_takendown) return false;
          let date = new Date(item.date_takendown);
          return date >= startDate && date <= endDate;
        });
      }
      setSortedProducts(filtered);
    } catch (err) {
      console.error("Error in filtering products:", err);
      handleFailureAlert("Error in filtering products");
    }
  };

  // Add filter effect
  useEffect(() => {
    // setSortedProducts(products["takenDown"] || []);
    handleFilter();
  }, [list, checkedPlatforms, abuse_type, dateFilter, products["takenDown"]]);

  return (
    <Box>
      {/* Main Fields */}
      {isLoading && <Loader />}
      <Card p="0px" w="100%">
        <Flex justify={"space-between"} m={2}>

          <Text px="20px" pt="10px">
            Count: {sortedProducts.length}

          </Text>
          <Flex gap={2}>
            <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
            <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

          </Flex>
        </Flex>


        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify="space-between"
          w="100%"
          px="22px"
          py="18px"
        >
          <SearchBar
            m="10px"
            borderRadius="30px"
            onChange={(e) => handleSearch(e.target.value)}
          />
          {isAdmin && (

            <Button
              variant="action"
              alignSelf="right"
              onClick={() => handleSaveChanges()}
            >
              Save Changes
            </Button>
          )}
        </Flex>

        {sortedProducts ? (
          <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

            {sortedProducts?.slice(0, productsToShow).map((prod, index) => (
              <ItemTakenDown
                key={index}
                index={index}
                product={prod}
                handleUpdateSeller={handleUpdateSeller}
                removeFromUpdate={removeFromUpdate}
                statusUpdate={statusUpdate}
                setStatusUpdate={setStatusUpdate}
                isAdmin={isAdmin}
                viewMode={viewMode}
                abuseTypes={abuse_type}
              />
            ))}
          </SimpleGrid>
        ) : (
          <>
            <Text>Loading ...</Text>
          </>
        )}
      </Card>
      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>
      <Link>
        <Text
          color={textColor}
          fontSize="l"
          fontWeight="500"
          onClick={() => loadLess()}
          r="0"
          position="absolute"
          right={{ base: "10%", md: "15%", sm: "30%" }}
          textDecoration="underline"
        >
          Show less...
        </Text>
      </Link>
      <Link>
        <Text
          color={textColor}
          fontSize="l"
          fontWeight="500"
          onClick={() => loadMore()}
          r="0"
          position="absolute"
          right={{ base: "2%", md: "5%" }}
          textDecoration="underline"
        >
          Show more...
        </Text>
      </Link>
      {/* Delete Product */}
    </Box>
  );
}
